module.exports = __webpack_public_path__ + "static/media/error-icon.f5607f63.svg";